export default __webpack_public_path__ + "static/media/banner.95ed6f20.png";